import React, { useEffect, useState } from "react";
import search from "../../assets/images/search-lg.svg";
import CustomInput from "../../Common/CustomInput/CustomInput";
import { useStateContext } from "../../Common/Context/StateContext";

const ContactHeader = ({ addmodel, setOpenFilter, params, setParams }) => {
  const { currentCardTitle, currentUrl } = useStateContext();
  const [searchtext, setSearchtext] = useState(params?.search_key || "");
  const [debouncedSearchtext, setDebouncedSearchtext] = useState(searchtext);

  useEffect(() => {
    setSearchtext(params?.search_key || "");
  }, [params?.search_key]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchtext(searchtext);
    }, 600);
    return () => {
      clearTimeout(handler);
    };
  }, [searchtext]);

  useEffect(() => {
    setParams((prevParams) => ({
      ...prevParams,
      search_key: debouncedSearchtext,
    }));
  }, [debouncedSearchtext, setParams]);

  const handleClear = () => {
    setParams({
      status: null,
      gender: null,
      search_key: "",
      page: 1,
    });
  };

  return (
    <div className="py-3">
      <div className="category-wrapper d-flex justify-content-center flex-column w-100">
        <div className="d-flex justify-content-between align-items-center sub-head">
          <h4>{currentCardTitle}</h4>
          {/* <button
            className="background-button filter-btn"
            onClick={() => setOpenFilter(true)}
          >
            <span>
              <i className="fa-sharp fa-regular fa-filter"></i> Filter
            </span>
          </button> */}
        </div>
        <div className="searchbar d-flex justify-content-between align-items-center">
          <div className="col-md-6 p-0">
            <div className="search-bar d-flex w-100">
              <button className="btn">
                <img src={search} alt="search" />
              </button>
              <CustomInput
                value={searchtext}
                placeholder="Search details here"
                style={{ width: "100%", marginBottom: 20 }}
                onChange={({ target }) => setSearchtext(target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactHeader;
